"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Header = void 0;
const tslib_1 = require("tslib");
const jsx_runtime_1 = require("react/jsx-runtime");
const NavItem_1 = require("../../../nav/NavItem");
const Link_1 = require("../../link/Link");
const UI_1 = require("../../UI");
const UserHeaderNav_1 = require("./UserHeaderNav");
function Header(_a) {
    var { brand, navItems = [], UserHeaderNavComponent } = _a, navbarProps = tslib_1.__rest(_a, ["brand", "navItems", "UserHeaderNavComponent"]);
    let brandContent = null;
    const { useLink } = UI_1.useUIContext();
    if (brand) {
        const linkProps = Link_1.isLinkProps(brand) ? brand : { href: "/", children: brand };
        brandContent = useLink(linkProps);
    }
    if (!UserHeaderNavComponent) {
        UserHeaderNavComponent = UserHeaderNav_1.UserHeaderNav;
    }
    return (jsx_runtime_1.jsxs("header", Object.assign({}, navbarProps, { children: [brandContent, jsx_runtime_1.jsxs("nav", { children: [jsx_runtime_1.jsx("ul", { children: jsx_runtime_1.jsx(NavItem_1.NavItems, { navItems: navItems }, void 0) }, void 0),
                    jsx_runtime_1.jsx(UserHeaderNavComponent, {}, void 0)] }, void 0)] }), void 0));
}
exports.Header = Header;
//# sourceMappingURL=Header.js.map